var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMicrophone = function SvgMicrophone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 368.896,
    height: 469.332,
    viewBox: "0 0 368.896 469.332",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microphone_2_",
    "data-name": "microphone (2)",
    transform: "translate(-54.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(231.294 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1461",
    "data-name": "Group 1461"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 96.192,
    cy: 96.192,
    r: 96.192
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(54.782 133.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M160.14,365.174a47.5,47.5,0,0,0-33.808,14l-11.8,11.8a16.911,16.911,0,1,1-23.916-23.916l13.038-13.039a36.119,36.119,0,0,0,34.386-5.533L290.062,229.858a127.6,127.6,0,0,1-84.094-84.1L87.336,297.784A36.116,36.116,0,0,0,81.8,332.17L68.765,345.209a47.815,47.815,0,0,0,67.62,67.62l11.8-11.8A16.911,16.911,0,0,1,172.1,424.948l-34.681,34.68,21.852,21.852L193.95,446.8a47.816,47.816,0,0,0-33.81-81.626Z",
    transform: "translate(-54.783 -145.761)"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Microphone.992bb2f693e0119a51bd436cad48a92a.svg";